import { Gender } from "../common/Gender";

export interface Coach {
  id: number | null;
  firstName: string;
  lastName: string;
  gender: Gender;
  birthDate: string;
  address: string;
  email: string;
  phone: string;
  nationalId: string;
  note: string;
  nickname: string;
  wage: number;
  tax: number;
  accountNumber: string;
}

export const coachInit: Coach = {
  id: null,
  firstName: "",
  lastName: "",
  gender: Gender.NONE,
  birthDate: "",
  address: "",
  email: "",
  phone: "",
  nationalId: "",
  note: "",
  nickname: "",
  wage: 0,
  tax: 0,
  accountNumber: "",
}
